import { createSlice } from "@reduxjs/toolkit";
import {
  removeItemFromBasket,
  createOrder,
  fetchOrder,
  removeBasket,
  updateBasket,
} from "../basket/basketSlice";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: {
      order: null,
    },
    isLoggedIn: false,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isLoggedIn = true;
    },
    unsetUser: (state) => {
      state.user = {};
      state.isLoggedIn = false;
      window.localStorage.removeItem("order");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(removeItemFromBasket.fulfilled, (state, action) => {
        if (action.payload.length === 0) {
          //console.info("panier vide.");
          delete state.user.order;
          if (!state.user.isSwitchedUser) {
            //console.info('remove localStorage "order"');
            window.localStorage.removeItem("order");
          }
        }
      })
      .addCase(createOrder.fulfilled, (state, response) => {
        if (response?.payload) {
          state.user.order = response?.payload["@id"];
          if (!state.user.isSwitchedUser) {
            /*
            console.info(
              'create localStorage "order"',
              response?.payload["@id"]
            );
            */
            window.localStorage.setItem("order", response?.payload["@id"]);
          }
        }
      })
      .addCase(fetchOrder.fulfilled, (state, response) => {
        if (!response.payload) {
          window.localStorage.removeItem("order");
          delete state.user.order;
        }
      })
      .addCase(removeBasket.fulfilled, (state, response) => {
        window.localStorage.removeItem("order");
        delete state.user.order;
      })
      .addCase(updateBasket.fulfilled, (state, response) => {
        state.loading = false;
        if (
          response?.payload &&
          response.payload.state !== "in_progress" &&
          response.payload["@id"] === state.user.order
        ) {
          window.localStorage.removeItem("order");
          delete state.user.order;
        }
      });
  },
});

export const { setUser, unsetUser } = authSlice.actions;
export default authSlice.reducer;
